import { render, staticRenderFns } from "./traineesApproval.vue?vue&type=template&id=74bbf46a&scoped=true"
import script from "./traineesApproval.vue?vue&type=script&lang=js"
export * from "./traineesApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bbf46a",
  null
  
)

export default component.exports